<div *ngFor="let item of [].constructor(amountOfBlocks)" class="tools__block">
	@if (carouselContent) {
		<ng-container [ngTemplateOutlet]="carouselContent" />
	}
</div>
